import { isProduction } from '@/config/env'

/**
 * 手动页面上报
 * @param {object} params
 */
const qdImp = (cls: string, v?: Record<string, any>): void => {
  if (!cls) return
  if (
    !window.__qd__ ||
    Object.prototype.toString.call(window.__qd__) !== '[object Object]'
  )
    return
  if (typeof window.__qd__.imp !== 'function') return

  try {
    // if (!isProduction) return
    window.__qd__.imp({
      cls,
      v
    })
  } catch (error) {
    console.log('qdImp error', error)
  }
}

/**
 * 手动页面上报
 * @param {object} params
 */
const qdPage = (params: Record<string, any>): void => {
  if (
    !window.__qd__ ||
    Object.prototype.toString.call(window.__qd__) !== '[object Object]'
  )
    return
  if (typeof window.__qd__.page !== 'function') return

  try {
    // if (!isProduction) return;
    if (params) {
      window.__qd__.page(params)
    } else {
      window.__qd__.page()
    }
  } catch (error) {
    console.log('qdPage error', error)
  }
}

/**
 * 点击上报
 * @param {string} cls 埋点id 'T1|T2'
 * @param {object} v 扩展参数
 */
const qdClick = (cls: string, v?: Record<string, any>): void => {
  if (!cls) return
  if (
    !window.__qd__ ||
    Object.prototype.toString.call(window.__qd__) !== '[object Object]'
  )
    return
  if (typeof window.__qd__.click !== 'function') return

  try {
    // if (!isProduction) return
    window.__qd__.click({
      cls,
      v
    })
  } catch (error) {
    console.log('qdClick error', error)
  }
}

/**
 * 自定义事件上报
 * @param {string} evt 事件名称
 * @param {object} v 扩展参数，包括cls埋点id等
 *  {
 *    cls: 'T1|T2',
 *    // 其他参数
 *  }
 */
const qdEvent = (cls: string, v: Record<string, any>): void => {
  if (!cls) return
  if (
    !window.__qd__ ||
    Object.prototype.toString.call(window.__qd__) !== '[object Object]'
  )
    return
  if (typeof window.__qd__.event !== 'function') return

  try {
    // if (!isProduction) return
    window.__qd__.event({
      cls,
      v
    })
  } catch (error) {
    console.log('qdEvent error', error)
  }
}

export { qdPage, qdImp, qdClick, qdEvent }
